<template>
  <div class="list-rank-container">
    <div class="event-container-outer">
      <div class="event-header">
        <p>{{ listLabel ? listLabel : (listType == 'permission') ? 'Permission' : (listType == 'absent') ? 'Absent' : (listType == 'late') ? 'Late' : '' }}</p>
      </div>

      <div class="event-content">
        <div
          v-if="!listLoad && listData?.employee?.length"
          class="event-content-outer"
        >
          <div
            v-for="(data, index) in listData.employee.slice(0, 10)"
            :key="data.id || index"
            @click="openDetailList(data)"
            class="event-content-list"
          >
            <table>
              <tr>
                <!-- <td>Testing</td> -->
                <!-- <td>Testing</td> -->
                <td :rowspan="(data.dates?.length > 1) || (data.total) ? 2 : 1" style="font-size: 20px; width: 40px;">{{ index + 1 }}</td>
                <td style="font-weight: 600; width: calc(100% - 40px);">{{ data.name }}</td>
              </tr>
              <tr>
                <!-- <td style=" font-size: 12px; line-height: 20px; color: gray;">{{ data.teacher_id }}</td> -->
                <!-- <td v-if="data.dates > 1" style=" font-size: 12px; line-height: 20px; color: gray; color: #d50000;">{{ (listType == 'permission') ? 'Permission' : (listType == 'absent') ? 'Absent' : (listType == 'late') ? 'Late' : '' }} history {{ (data.dates.length > 1) || (data.total > 1) ? `( ${data.dates.length ?? data.total} )` : '' }}</td> -->
                <td v-if="data.time_in">
                  Tardy: {{ data.time_in }}, <span style="font-size: 12px; line-height: 20px; color: #d50000;">history ( {{ data.total }} )</span>
                </td>
                <td
                  v-else-if="data.dates?.length > 1"
                  style="font-size: 12px; line-height: 20px; color: #d50000;"
                >
                  {{
                    listType === 'permission'
                      ? 'Permission'
                      : listType === 'absent'
                      ? 'Absent'
                      : listType === 'late'
                      ? 'Late'
                      : ''
                  }}
                  history
                  {{
                    (data.dates?.length > 1 || data.total > 1)
                      ? `( ${data.dates?.length ?? data.total} )`
                      : ''
                  }}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div v-if="!listLoad && (listData?.employee?.length == 0)" class="event-content-outer">
          <div class="event-null">
            <p>{{ (listType == 'absent') ? 'No teachers were absent today' : (listType == 'permission') ? 'No teachers were permission today' : 'No teachers were tardy today' }}</p>
          </div>
        </div>

        <div v-else-if="listLoad" class="event-content-outer">
          <div v-for="value in 5" :key="value" class="event-load" />
        </div>
      </div>
    </div>
  </div>

  <vue-final-modal
    v-model="modalDetailList" classes="flex justify-center items-center py-10 px-4" content-class="w-full max-w-md h-auto"
    :ssr="true" :lock-scroll="true" :hide-overlay="false" :click-to-close="false" :esc-to-close="true" :prevent-click="true" :attach="false" transition="vfm" overlay-transition="vfm" :z-index-auto="true" :z-index-base="1000" :z-index="false" :focus-retain="true" :focus-trap="false"
    :fit-parent="true" :drag="false" drag-selector="" :keep-changed-style="false" :resize="false" :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']" :min-width="250" :min-height="250" :max-width="Infinity" :max-height="Infinity"
  >
    <div class="modal-head pt-5 pb-5">
      <h1>{{ (listType == 'late') ? 'list of tardy' : (listType == 'absent') ? 'list of absent' : '' }}</h1>
      <jb-button class="btn-close-modal" :icon="mdiClose" @click="openDetailList()" />
    </div>

    <div class="modal-all-event">
      <div v-if="dataDetailList?.dates" class="all-event-container">
        <div v-for="data in dataDetailList?.dates" :key="data" class="all-event-list">
          <p v-html="dataDetailList.name + ' (' + dataDetailList.ein + ')'" />
          <p v-html="(listType == 'late') ? `Tardy: ${data.time_in}` : dateFormat(data)" />
          <p v-if="(listType == 'late')" v-html="dateFormat(data.date)" />
        </div>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onUnmounted, watch, watchEffect, computed, nextTick } from 'vue'
  import { mdiClose } from '@mdi/js'
  import axios from 'axios'
  import dayjs from 'dayjs'
  import 'dayjs/locale/id'

  import JbButton from '@/components/JbButton'

  export default {
    components: {
      JbButton
    },

    props: {
      listLabel: { type: String, default: "" },
      listType: { type: String, default: "" },
      listData: { type: Array, default: () => [] },
      listLoad: { type: Boolean, default: false },
    },

    setup (props, { emit }) {
      // watchEffect(() => {
      //   if(props.listData) {
      //     console.log("cek employee top 10", props.listData)
      //   }
      // })


      const dataDetailList = ref({})
      const modalDetailList = ref(false)
      const openDetailList = (data) => {
        if(data) {
          dataDetailList.value = data
          modalDetailList.value = true
        }
        else {
          modalDetailList.value = false
          dataDetailList.value = ({})
        }
      }


      dayjs.locale('id')
      const dateFormat = (date1, date2 = null) => {
        const d1 = dayjs(date1)
        const d2 = date2 ? dayjs(date2) : null

        if (!d1.isValid()) return ''

        if (!d2 || !d2.isValid()) {
          return d1.format('D MMMM YYYY')
        }

        if (d1.isSame(d2, 'day')) {
          return d1.format('D MMMM YYYY')
        }

        const sameMonth = d1.isSame(d2, 'month')
        const sameYear = d1.isSame(d2, 'year')

        if (sameMonth && sameYear) {
          return `${d1.format('D')}-${d2.format('D MMMM YYYY')}`
        }

        if (!sameMonth && sameYear) {
          return `${d1.format('D MMM')} - ${d2.format('D MMM YYYY')}`
        }

        return `${d1.format('D MMM YYYY')} - ${d2.format('D MMM YYYY')}`
      }


      return {
        mdiClose,
        dataDetailList,
        modalDetailList,
        openDetailList,
        dateFormat
      }
    }
  }
</script>

<style lang="scss">
  .list-rank-container {
    .event-container-outer {
      width: 100%;
      height: auto;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;

      .event-header {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 16px;
        background-color: #152751;

        p {
          width: 100%;
          text-align: center;
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          color: white;
        }
      }

      .event-content {
        width: 100%;
        height: calc(520px - 40px - 40px);
        overflow-y: auto;
        background-color: white;

        .event-content-outer {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 8px;

          .event-content-list {
            width: 100%;
            padding: 8px;
            position: relative;
            cursor: pointer;
            transition: background-color .3s;

            &::before {
              content: '';
              width: 100%;
              height: 1px;
              background-color: lightgray;
              position: absolute;
              bottom: -4px;
              left: 0;
            }

            &:nth-last-child(1) {
              &::before {
                display: none;
              }
            }

            &:hover {
              background-color: whitesmoke;
            }

            // p {
            //   width: 100%;

            //   &:nth-child(1) {
            //     font-size: 14px;
            //     line-height: 20px;
            //     font-weight: 600;
            //     display: -webkit-box;
            //     -webkit-line-clamp: 2;
            //     -webkit-box-orient: vertical;
            //     overflow: hidden;
            //     margin-bottom: 4px;
            //   }

            //   &:nth-child(2) {
            //     width: max-content;
            //     background-color: #152751;
            //     padding: 4px 12px;
            //     border-radius: 12px;
            //     font-size: 12px;
            //     line-height: 18px;
            //     font-weight: 500;
            //     color: white;
            //   }

            //   &:nth-child(3) {
            //     text-align: right;
            //     font-size: 12px;
            //     line-height: 18px;
            //     font-weight: 600;
            //   }
            // }

            table {
              width: 100%;
              height: auto;

              tr {
                td {
                  font-size: 14px;
                  line-height: 24px;
                  font-weight: 500;
                  padding: 0;
                }
              }
            }
          }

          .event-null {
            width: 100%;
            height: calc(520px - 40px - 40px - 8px - 8px);
            display: flex;
            align-items: center;

            p {
              width: 100%;
              height: auto;
              text-align: center;
              font-size: 16px;
              line-height: 24px;
              font-weight: 600;
            }
          }

          .skeleton {
            position: relative;
            overflow: hidden;
            background-color: #e3e3e3;

            &::after {
              content: "";
              position: absolute;
              inset: 0;
              transform: translateX(-100%);
              background: linear-gradient(
                90deg,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0.5) 50%,
                rgba(255, 255, 255, 0) 100%
              );
              animation: shimmer 1.4s infinite;
            }
          }

          .event-load {
            @extend .skeleton;
            width: 100%;
            height: 60px;
          }

          @keyframes shimmer {
            100% {
              transform: translateX(100%);
            }
          }
        }
      }
    }
  }
</style>
